// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1qdjl","box":"WorkspacesBox_box__E2vPI","node":"WorkspacesBox_node__3l_en"};